import { render, staticRenderFns } from "./inspectionResponsible.vue?vue&type=template&id=a8bd4b3c"
import script from "./inspectionResponsible.vue?vue&type=script&lang=js"
export * from "./inspectionResponsible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports